import { render, staticRenderFns } from "./leadOpinionDetals.vue?vue&type=template&id=0ee45c3a&"
import script from "./leadOpinionDetals.vue?vue&type=script&lang=js&"
export * from "./leadOpinionDetals.vue?vue&type=script&lang=js&"
import style0 from "./leadOpinionDetals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports